<template>
	<VTooltip>
		<slot></slot>
		<template #popper> {{ tooltip }}</template>
	</VTooltip>
</template>

<script setup lang="ts">
defineProps<{
	tooltip: string;
}>();
</script>
